
import { styled } from "@mui/material";
import Button from "@mui/material/Button";

const RoundButtonStyle = styled(Button)(({theme}) => ({
   background: "transparent",
    color: "black",
    border: `2px solid ${theme.palette.borders.default}`,
    borderRadius: "999px",
    minWidth: "77px"
    }
))


const RoudedButton = ({text="",sx}) =>{
    return (

        <RoundButtonStyle sx={sx}>
            {text}
        </RoundButtonStyle>
    )
}

export default RoudedButton